import { render, staticRenderFns } from "./PatentDetail.vue?vue&type=template&id=35ead04c&scoped=true&"
import script from "./PatentDetail.vue?vue&type=script&lang=js&"
export * from "./PatentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PatentDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PatentDetail.vue?vue&type=style&index=1&id=35ead04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ead04c",
  null
  
)

export default component.exports